import { useMemo } from 'react';

import { FeatureFlag, useFeatureFlags } from '@cloudquery/base-users';

interface AllowedPlatformFeatures {
  aiAssistantAllowed: boolean;
  customColumnsAllowed: boolean;
  dataPermissionsAndRolesEnabled: boolean;
  editAdminTeamsAllowed: boolean;
  hideAllData: boolean;
  policiesAllowed: boolean;
  readonlyUserEditDisabled: boolean;
  syncFinalizingTimeoutMins: number;
}

export const useAllowedPlatformFeatures = (): AllowedPlatformFeatures => {
  const { featureFlags } = useFeatureFlags();

  const policies = featureFlags[FeatureFlag.ALLOWED_TO_VIEW_POLICIES];
  const editAdminTeams = featureFlags[FeatureFlag.ALLOWED_TO_EDIT_ADMIN_TEAMS];
  const { enabled: customColumns } = featureFlags[FeatureFlag.ALLOWED_CUSTOM_COLUMNS];
  const readonlyUserEditDisabled = featureFlags[FeatureFlag.READONLY_USER_EDIT_DISABLED];
  const aiAssistant = featureFlags[FeatureFlag.AI_ASSISTANT];
  const syncFinalizingTimeoutMins = featureFlags[FeatureFlag.SYNC_FINALIZING_TIMEOUT_MINS];
  const hideAllData = featureFlags[FeatureFlag.HIDE_ALL_DATA];
  const dataPermissionsAndRolesEnabled =
    featureFlags[FeatureFlag.DATA_PERMISSIONS_AND_ROLES_ENABLED];

  return useMemo(() => {
    return {
      aiAssistantAllowed: String(aiAssistant) === 'true',
      customColumnsAllowed: String(customColumns) === 'true',
      dataPermissionsAndRolesEnabled: String(dataPermissionsAndRolesEnabled) === 'true',
      editAdminTeamsAllowed: String(editAdminTeams) === 'true',
      hideAllData: String(hideAllData) === 'true',
      policiesAllowed: String(policies) === 'true',
      readonlyUserEditDisabled: String(readonlyUserEditDisabled) === 'true',
      syncFinalizingTimeoutMins: Number(syncFinalizingTimeoutMins),
    };
  }, [
    customColumns,
    editAdminTeams,
    policies,
    readonlyUserEditDisabled,
    aiAssistant,
    syncFinalizingTimeoutMins,
    hideAllData,
    dataPermissionsAndRolesEnabled,
  ]);
};
